/** Created by azhou on 2019/1/16.*/
<template>
  <div>
    <!--white-->
    <div class="d-flex" v-if="inputType==='white'">
      <el-input placeholder="请输入验证码"
                v-model="phoneCode"
                prefix-icon="el-icon-mobile-phone"
                @blur="$emit('getCode',phoneCode)"/>
      <div class="get-code"
           :class="[getCodeFlag ? 'disabled-code' : '']"
           @click="getCode">
        <span v-show="getCodeFlag" class="ml-2">{{timeCount}}</span>
        <!-- <i class="el-icon-mobile-phone mr-1" v-show="!getCodeFlag"></i> -->
        {{getCodeFlag?'重新发送':'获取验证码'}}
      </div>
    </div>
    <!--grey-->
    <div class="register-input" v-if="inputType==='grey'">
      <span class="input-label">验证码</span>
      <input type="text"
             @blur="$emit('getCode',phoneCode)"
             v-model="phoneCode"
             placeholder="请输入验证码"/>
      <label class="send-code"
             :class="[getCodeFlag ? 'disabled-code-2' : '']"
             @click="getCode">
        <span v-show="getCodeFlag">({{timeCount}})</span>
        发送验证码
      </label>
    </div>
    <!--enterprise-->
    <div class="flsex" v-if="inputType==='enterprise'">
      <span class="liexs" :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
      <div class="d-center"><div class="form-left-text" :style="{width:width+'px'}">验证码</div>：</div>
      <div class="input-self" style="text-align:left;">
        <input type="text"
          @blur="$emit('getCode',phoneCode)"
          v-model="phoneCode"
          class="enterprise-input"
          placeholder="请输入验证码"/>
        <label class="send-codes"
              :class="[getCodeFlag ? 'disabled-code-2' : '']"
              @click="getCode">
          <span v-show="getCodeFlag">({{timeCount}})</span>
          发送验证码
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import _ from 'lodash'
  export default {
    name: 'SendPhoneCode',
    computed: {
      ...mapState(['userLoginMessage']),
      ...mapGetters(['userInfo'])
    },
    props: {
      width: {
        type: Number,
        default:100
      },
      required: {
        type: Boolean,
        default: true
      },
      phoneNumber: {
        type: String
      },
      emailNumber: {
        type: String
      },
      url: {
        type: String,
        default: '/pc/Reglogin/GetLoginCode'
      },
      template: {
        type: String,
        default: 'SMS_269220689'
      },
      inputType: {
        type: String,
        default: 'white'
      },
      sendType:{
        type:String,
        default:'mobile'
      },
      type:{},
    },
    data () {
      return {
        phoneCode: '',                          //手机、邮箱验证码
        getCodeFlag: false,                    //验证码发送标志，禁用时不再发送
        timeCount: 60,
        mobileverify:[]
      }
    },
    mounted(){
      this.isSendCode(this.phoneNumber);
    },
    watch: {
      phoneNumber(newVal){
        this.isSendCode(newVal);
        //  localStorage.setItem('mobileverify','12123456');
        if (this.$route.query.type == 'phone' && newVal == '') {
          this.phoneCode = ''; clearInterval(this._timer); this.timeCount = -1; this.getCodeFlag = false
        }
      }
    },
    destroyed () {
      clearInterval(this._timer)
    },
    methods: {
      getCode() {
        switch (this.sendType) {
          case 'mobile': this.getPhoneCode(); break;
          case 'email': this.getEmailCode(); break;
          default:break;
        }
      },
      //判断是否已经发送了验证码
      isSendCode(phoneNumber) {
        let mobileverify =JSON.parse(sessionStorage.getItem('mobileverify'))||[];
        let tiem=mobileverify.filter(todo=>todo.mobile==phoneNumber)[0];
        let nowTime=new Date().getTime();
        if(tiem&&(nowTime-tiem.tiem)<60000){
          console.log('已发送验证码')
          let num =60-(nowTime-tiem.tiem)/1000;
          this.timeCount=num.toFixed(0);
          this.getCodeFlag=true;
          this._timer = setInterval(() => {
            this.timeCount--
            if (this.timeCount <= 0) {
              clearInterval(this._timer)
              this.getCodeFlag = false
            }
          }, 1000)
        }
        this.mobileverify=mobileverify;
      },
      //发送验证码
      getPhoneCode:_.debounce(async function(newVal) {
        if (!this.$GFUN.isPhone(this.phoneNumber)) {
          this.$emit('showError', '手机号填写不正确')
          return
        }
        if (this.getCodeFlag) return
        let sdata = {
          mobile: this.phoneNumber,
          template: this.template
        }
        //供应商注册
        if(this.inputType==='enterprise'){
            //供应商酒店注册为mod
            if(!this.type){
              sdata.mob=this.phoneNumber;
              delete sdata.mobile;
            }
        }
        if(this.$route.name == 'AddGuide') sdata.type = 4
        let resData = await this.$axios.post(this.url, sdata)
        if (resData.code === '00000') {
          this.getCodeFlag = true;
          this.$message({message: '验证码发送成功',duration:1000})
          //保存已发送验证码手机号刷新再次发送情况
          const index = this.mobileverify.findIndex(user => user.mobile === this.phoneNumber);
          if (index !== -1) {
             this.mobileverify[index]={mobile:this.phoneNumber,tiem:new Date().getTime()};
          }else{
              this.mobileverify.push({mobile:this.phoneNumber,tiem:new Date().getTime()});
          }
          sessionStorage.setItem('mobileverify',JSON.stringify(this.mobileverify));
          // const value = localStorage.getItem('mobileverify');
          this.timeCount = 60
          this._timer = setInterval(() => {
            this.timeCount--
            if (this.timeCount <= 0) {
              clearInterval(this._timer)
              this.getCodeFlag = false
            }
          }, 1000)
        } else 
        if (resData.code === '99999') {this.$emit('showError', '手机号未注册');this.getCodeFlag = false};
        if (resData.code === '10088') {this.$emit('showError', '手机号已被占用');this.getCodeFlag = false}
      },200),
      /*获取邮箱验证码*/
      async getEmailCode () {
        if (!this.$GFUN.isEmail(this.emailNumber)) {
          this.$emit('showError', '邮箱填写不正确')
          return
        }
        if (this.getCodeFlag) return
        let resData = await this.$axios.post(this.url, {
          //store_id: this.userLoginMessage.store_ids[0],
          email: this.emailNumber,
          type: 'send'
        })
        if (resData.code === '00000') {
          this.$message.success('验证码发送成功')
          this.getCodeFlag = true
          this.timeCount = 60
          this._timer = setInterval(() => {
            this.timeCount--
            if (this.timeCount <= 0) {
              clearInterval(this._timer)
              this.getCodeFlag = false
            }
          }, 1000)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/assets/css/color.scss';
  .flsex{
    display: flex;
  }
  .input-self{
    display: flex;
    width: 242px;
  }
  .liexs{
    margin-top: 10px;
  }
  .el-input ::v-deep .el-input__inner {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  .get-code {
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: $loginBlue;
    cursor: pointer;
    user-select: none;
  }

  .disabled-code {
    background: #f5f5f5;
    cursor: not-allowed;
    color: #999;
  }

  .register-input {
    background: #eee;
    border: 1px solid #ccc;
    margin: 20px auto;
    border-radius: 5px;
    padding: 0 0 0 5px;
    height: 37px;
    width: 355px;
    display: flex;
    align-items: center;
    .input-label {
      width: 60px;
      margin-right: 10px;
      display: inline-block;
      text-align-last: justify;
      font-size: 14px;
    }
    input {
      -webkit-appearance: none;
      -moz-appearance: none;
      border: none;
      background: #eee;
      height: 37px;
      width: 100px;
      &:focus {
        outline: none;
      }
    }
  }
  .enterprise-input{
      border: 1px solid #dcdfe6;
      padding: 3px 0px;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      width: 70%;
      padding: 0 3%;
      border-radius:3px 0 0 3px;
      font-size: 14px;
      line-height: 32px;
            &:focus{
        outline: none;
        border: 1px solid #26a2ff;
      }
  }

  .send-code {
    width: 110px;
    height: 37px;
    line-height: 37px;
    font-size: 14px;
    background: #f8f9fa;
    color: $loginBlue;
    cursor: pointer;
    border-radius: 5px;
    box-shadow: -3px 0 5px 0 #bbb;
    margin-left: auto;
    user-select:none;
    &:hover{
      box-shadow: -3px 0 5px 0 #aaa;
    }
  }
  .send-codes{
    width: 110px;
    height: 37px;
    line-height: 37px;
    font-size: 14px;
    background: #f8f9fa;
    color: $loginBlue;
    cursor: pointer;
    border-radius: 0 5px 5px 0;
    text-align: center;
    margin-left: auto;
    user-select:none;
    background-color: var(--smtc-color-primary) !important;
    color: #fff;
    // &:hover{
    //   box-shadow: -3px 0 5px 0 #aaa;
    // }
  }
  .disabled-code-2{
    cursor: not-allowed;
    opacity: .6;
  }
</style>
